/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Credentials_InstructionsInputs */

const en_vault_credentials_instructions = /** @type {(inputs: Vault_Credentials_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credentials & Instructions`)
};

const es_vault_credentials_instructions = /** @type {(inputs: Vault_Credentials_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credenciales e Instrucciones`)
};

const fr_vault_credentials_instructions = /** @type {(inputs: Vault_Credentials_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifiants et Instructions`)
};

const de_vault_credentials_instructions = /** @type {(inputs: Vault_Credentials_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldeinformationen & Anweisungen`)
};

const id_vault_credentials_instructions = /** @type {(inputs: Vault_Credentials_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredensial & Instruksi`)
};

/** @type {(inputs: Vault_Credentials_InstructionsInputs) => LocalizedString} */
const ja_vault_credentials_instructions = en_vault_credentials_instructions;

/** @type {(inputs: Vault_Credentials_InstructionsInputs) => LocalizedString} */
const zh_vault_credentials_instructions = en_vault_credentials_instructions;

/** @type {(inputs: Vault_Credentials_InstructionsInputs) => LocalizedString} */
const ar_vault_credentials_instructions = en_vault_credentials_instructions;

/** @type {(inputs: Vault_Credentials_InstructionsInputs) => LocalizedString} */
const it_vault_credentials_instructions = en_vault_credentials_instructions;

/** @type {(inputs: Vault_Credentials_InstructionsInputs) => LocalizedString} */
const ru_vault_credentials_instructions = en_vault_credentials_instructions;

/** @type {(inputs: Vault_Credentials_InstructionsInputs) => LocalizedString} */
const pt_vault_credentials_instructions = en_vault_credentials_instructions;

/** @type {(inputs: Vault_Credentials_InstructionsInputs) => LocalizedString} */
const ko_vault_credentials_instructions = en_vault_credentials_instructions;

/**
* | output |
* | --- |
* | "Credentials & Instructions" |
*
* @param {Vault_Credentials_InstructionsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_credentials_instructions = /** @type {((inputs?: Vault_Credentials_InstructionsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Credentials_InstructionsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_credentials_instructions(inputs)
	if (locale === "es") return es_vault_credentials_instructions(inputs)
	if (locale === "fr") return fr_vault_credentials_instructions(inputs)
	if (locale === "de") return de_vault_credentials_instructions(inputs)
	if (locale === "ja") return ja_vault_credentials_instructions(inputs)
	if (locale === "zh") return zh_vault_credentials_instructions(inputs)
	if (locale === "ar") return ar_vault_credentials_instructions(inputs)
	if (locale === "id") return id_vault_credentials_instructions(inputs)
	if (locale === "it") return it_vault_credentials_instructions(inputs)
	if (locale === "ru") return ru_vault_credentials_instructions(inputs)
	if (locale === "pt") return pt_vault_credentials_instructions(inputs)
	return ko_vault_credentials_instructions(inputs)
});